import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree  } from "@angular/router";
import { Observable } from 'rxjs';
import {Router, ActivatedRoute} from "@angular/router";
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private userService: UserService,   private route: ActivatedRoute,
    ) { }
  canActivate(route: ActivatedRouteSnapshot, router: RouterStateSnapshot): |boolean |UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree>  {
   const currentUser = localStorage.getItem('nu_c_user_id')
         if(currentUser){
           return true;
         }
         return this.router.createUrlTree(['/'])
  }

  userPermissions(slug=''){
		const currentUser = localStorage.getItem('nu_c_user_id');
    let current_url = this.router.url;
    current_url = current_url.replace('/','');
    if(current_url.includes("/")){
      let current_url_arr = current_url;
      const current_url_checkout = current_url_arr.split("/");
      current_url = current_url_checkout[0];
     // console.log(current_url_checkout);
     // console.log(current_url_checkout[0]);
    }
   
     
    current_url = current_url == 'manage-subscriptions' ? 'subscriptions' : current_url;
    console.log(current_url);
    this.userService.get_user_permissions(currentUser).subscribe((data: any) => {
      console.log(data);
      var sub_admin= data['userData']['sub_admin'];
      console.log(sub_admin);
      var permissions= data['permissions'];
      const current_permission = permissions[current_url];
      if(sub_admin == 1){
        if (typeof current_permission === 'undefined')
        {
         this.router.navigate(['/']);
        }
      }
    });
		
	}
} 
